import { Link } from 'react-router-dom'
import {
  getFormSlugOrId,
  useFormsDefinitions,
} from '../../providers/FormDefinitionsProvider'
import LoadingSpinner from '../../components/LoadingSpinner'
import ErrorMessage from '../../components/ErrorMessage'
import { CenteredPageContent } from '../../components/LayoutComponents'
import styled from 'styled-components'

const FormsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
FormsListContainer.displayName = 'FormsListContainer'

function FormList() {
  const { forms, isFetching } = useFormsDefinitions()

  if (isFetching) {
    return <LoadingSpinner>Fetching forms</LoadingSpinner>
  }

  if (!forms) {
    return <ErrorMessage>There was an issue retrieving forms</ErrorMessage>
  }

  if (!forms.length) {
    return <p>There are no forms</p>
  }

  return (
    <CenteredPageContent>
      <FormsListContainer>
        {forms.map((form) => (
          <Link key={form.id} to={`/forms/${getFormSlugOrId(form)}`}>
            {form.name}
          </Link>
        ))}
      </FormsListContainer>
    </CenteredPageContent>
  )
}

export default FormList
